import { render, staticRenderFns } from "./aligns.vue?vue&type=template&id=709fe848&scoped=true&lang=pug"
import script from "./aligns.vue?vue&type=script&lang=js"
export * from "./aligns.vue?vue&type=script&lang=js"
import style0 from "./aligns.vue?vue&type=style&index=0&id=709fe848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fe848",
  null
  
)

export default component.exports